import axios from '@ts/utils/axios';
import { ApiRequestError } from '@ts/utils/errors';

export const fetch = (params = {}, rest = {}) =>
    axios.get('/category', { params, ...rest }).then(({ data }) => {
        if (data && Array.isArray(data.items)) {
            return data.items;
        }

        throw new ApiRequestError('Failed fetch categories: /category', { params, rest });
    });

export const fetchFeatured = (params = {}, rest = {}) =>
    axios
        .get('/categories', { params: { is_featured: 1, ...params }, ...rest })
        .then(({ data }) => {
            if (data && Array.isArray(data.items)) {
                return data.items;
            }
            throw new ApiRequestError('Failed fetch categories: /categories', { params, rest });
        });
